// Suoni del giveaway.
// Iscrizione (sparkle) e vittoria (fanfara): MP3 in /public/sounds via HTMLAudio.
// Ruota: tick sintetizzato (Web Audio) a OGNI cambio nome sullo schermo —
// sincronizzato per costruzione: rallenta e si ferma esattamente con la ruota.
// I browser sbloccano l'audio solo dopo un gesto dell'utente: initAudio() va
// chiamato sul primo click/tocco della pagina.

let ctx = null;

// Volume generale dei suoni del giveaway (barra del volume, salvato nel browser)
let masterVolume = 1;
try {
  const v = Number(localStorage.getItem("gv_volume"));
  if (!Number.isNaN(v) && v >= 0) masterVolume = Math.min(1, v);
} catch { /* noop */ }

export function getMasterVolume() {
  return masterVolume;
}

export function setMasterVolume(v) {
  masterVolume = Math.max(0, Math.min(1, v));
  try { localStorage.setItem("gv_volume", String(masterVolume)); } catch { /* noop */ }
}

export function initAudio() {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch { /* audio non supportato */ }
}

// true se il contesto audio e' attivo e i suoni possono partire
export function audioUnlocked() {
  try { return Boolean(ctx && ctx.state === "running"); } catch { return false; }
}

function play(path, volume = 0.8) {
  try {
    const a = new Audio(path);
    a.volume = Math.min(1, volume * masterVolume);
    a.play().catch(() => {});
  } catch { /* audio bloccato dal browser */ }
}

// "Sparkle" per ogni nuova iscrizione
export function playPop() {
  play("/sounds/iscrizione.mp3", 0.55);
}

// Fanfara del vincitore
export function playFanfare() {
  play("/sounds/vittoria.mp3", 0.9);
}

// Tick della ruota a ogni nome che scorre.
// energy 1 = inizio giro (acuto e rapido) -> 0 = fine giro (grave e lento).
export function playTick(energy = 1) {
  try {
    if (!ctx || ctx.state !== "running") return;
    const t0 = ctx.currentTime;
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "square";
    osc.frequency.setValueAtTime(700 + 800 * energy, t0);
    g.gain.setValueAtTime(0.045 * masterVolume, t0);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.035);
    osc.connect(g).connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + 0.05);
  } catch { /* noop */ }
}

// "Ding" finale quando la ruota si ferma sul vincitore
export function playDing() {
  try {
    if (!ctx || ctx.state !== "running") return;
    [1318.5, 1760].forEach((f, i) => {
      const t0 = ctx.currentTime + i * 0.08;
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = "triangle";
      osc.frequency.setValueAtTime(f, t0);
      g.gain.setValueAtTime(0.12 * masterVolume, t0);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.4);
      osc.connect(g).connect(ctx.destination);
      osc.start(t0);
      osc.stop(t0 + 0.45);
    });
  } catch { /* noop */ }
}

